import moment from 'moment';

export function getFallbackMomentLocale(): string {
  const browserLocale = navigator.language;
  // Check if the browser locale is supported by moment,
  // if not fallback to the language without the extra character (ex: en-GB-ext -> en-gb),
  // if that is also not supported fallback to English
  const momentLocale =
    moment.locales().find((l) => l === browserLocale.toLowerCase()) ??
    moment.locales().find((l) => l === browserLocale.toLowerCase().match(/^[a-z]+-[a-z]+/)?.[0]) ??
    'en';
  return momentLocale;
}

export interface DateMaskConfig {
  mask: string;
  placeholder: string;
  format: string;
}

export function getMomentDateMask(locale = getFallbackMomentLocale(), separatorOverride?: string): DateMaskConfig {
  let format = moment.localeData(locale).longDateFormat('L');

  format = format.replace(/\bM\b/g, 'MM').replace(/\bD\b/g, 'DD');

  if (separatorOverride) format = format.replace(/[^YMD]/g, separatorOverride);

  const mask = format.replace(/YYYY/g, '9999').replace(/MM/g, '99').replace(/DD/g, '99');
  const placeholder = format.replace(/YYYY/g, 'yyyy').replace(/MM/g, 'mm').replace(/DD/g, 'dd');

  return { mask, placeholder, format };
}
